<template>
    <div class="practitioner-admin mt-page">

        <b-row>
            <b-col>
                <h1>
                    {{ $i18n.gt('HEADING_MANAGE_PRACTITIONERS_FOR') }} {{ practice.name }}
                </h1>
            </b-col>
            <b-col class="text-right">
                <router-link class="btn btn-ghost-blue mr-3 mb-3"
                             :to="createRoute">
                    <shs-icon name="plus"></shs-icon>
                    {{ $i18n.gt('LABEL_NEW_PRACTITIONER') }}
                </router-link>
            </b-col>
        </b-row>

        <practitioner-list :practice-id="computedPracticeId"></practitioner-list>

    </div>
</template>

<script>

    import Vue from 'vue'
    import {store} from '@/apps/default/store'

    /**
     * Page to manage Practitioners for a Practice - either by an admin or by a practice manager/practitioner
     */
    export default Vue.extend({
        name: "PractitionerAdmin",
        props: {
            practiceId: Number  // not present under practice manager route
        },
        data() {
            return {
                practice: {}
            }
        },
        computed: {
            computedPracticeId() {
                if (this.practiceId) {
                    return this.practiceId
                } else {
                    return this.$user.practitionerPracticeId()
                }
            },
            createRoute() {
                if (this.$user.roleIsAdmin()) {
                    return `/practitioner/create/companyId/${this.practice.company_id}/practiceId/${this.computedPracticeId}`
                } else {
                    return `/practice/practitionerCreate`
                }
            }
        },
        mounted() {
            this.$api.getItem(this, 'practice', this.computedPracticeId)
                .then((practice) => {
                    this.practice = practice
                })
        }
    })

</script>
